module.exports = __webpack_public_path__ + "fonts/Rubik-300-latin63.b65daad.woff2";